import { render, staticRenderFns } from "./zuoyidong.vue?vue&type=template&id=03b5f04c&scoped=true&"
import script from "./zuoyidong.vue?vue&type=script&lang=js&"
export * from "./zuoyidong.vue?vue&type=script&lang=js&"
import style0 from "./zuoyidong.vue?vue&type=style&index=0&id=03b5f04c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b5f04c",
  null
  
)

export default component.exports